import {observable, action} from "mobx";

// Welcome message
const welcome = {
  message: `Welcome to Persona Generator. You can edit any of this default content to make your own persona by
  clicking into a field.`,
  type: "info",
  dismissable: true
};

// Edit only mode
const viewOnly = {
  message: `You are in view only mode. This will let you see changes made to the original but you will not be able
   to make changes.`,
  type: 'warning',
  timer: 5000
};

// New persona
const newPersona = {
  message: `We created a new space for your persona. You can use the links in the sidebar to copy for viewing or
  editing. The app will auto save your work.`,
  type: 'success',
  timer: 7000,
  dismissable: true
};

const emailNotice = (email) => ({
  type: 'info',
  message: `We are sending an email to ${email} with the info.`,
  timer: 5000,
  dismissable: true
});

export default class AlertStore {
  @observable alerts = [];

  @action
  addAlert = (alert) => {
    let alerts = this.alerts;
    alerts.push(alert);
  }

  @action
  dismissAlert = (index, e) => {
    this.alerts.splice(index, 1);
  }

  @action
  dismissAllAlerts = () => {
    this.alerts = [];
  }

  addWelcomeAlert = () => {
    this.addAlert(welcome);
  }

  addViewOnlyAlert = () => {
    this.addAlert(viewOnly);
  }

  addEmailAlert = (email) => {
    this.addAlert(emailNotice(email));
  }

  addCreateAlert = () => {
    this.addAlert(newPersona);
  }

  addError = (message) => {
    this.addAlert({
      type: 'warning',
      message,
      dismissable: true,
    });
  }
}



// WEBPACK FOOTER //
// ./client/modules/AlertStore.js